import React from "react";
import NoResults from "../../common/component/NoResults";
import { Typography } from "../../UI/Typography";
import { Table } from "../../UI/Table";
import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { Grid } from "../../UI/Grid";
import { COLOR_BLUE_BAYOUX } from "../../constants/styles";
import { UserRemoveResultsTableBody } from "./UserRemoveResultsTableBody";

interface IProps {
  results: any[];
  onSuccess: (id: string) => VoidFunction;
}

export const UserRemoveResultsTable: React.FC<IProps> = (props) => (
  <>
    {!!props.results.length && (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2" color={COLOR_BLUE_BAYOUX}>
            {props.results.length} user(s) found
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Table padding="checkbox">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Roomsync ID</TableCell>
                <TableCell>Community</TableCell>
                <TableCell>Subnetwork</TableCell>
                <TableCell>Unit</TableCell>
                <TableCell>Bedroom</TableCell>
                <TableCell>Registered</TableCell>
                <TableCell>Registration Date</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <UserRemoveResultsTableBody users={props.results} onSuccess={props.onSuccess} />
          </Table>
        </Grid>
      </Grid>
    )}
    {!props.results.length && <NoResults />}
  </>
);

